import { Component, OnInit, ChangeDetectorRef, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { ErrorDialogComponent } from '../../dialog/errordialog/error.dialog.component';

import { UserLoginService } from '../../service/aws/user.login.service';

export interface DialogData {
    error: 'nouser' | 'unexpected' | 'nolink';
}

@Component({
    selector: 'app-employee-engagementlogin',
    styleUrls: ['login.component.scss'],
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {
    email: string;
    password: string;
    errorMessage: string;
    mfaStep = false;
    mfaData = {
        destination: '',
        callback: null
    };

    constructor(private router: Router,
                private userService: UserLoginService,
                private changeDetector: ChangeDetectorRef,
                private dialog: MatDialog) {
        // console.log("LoginComponent constructor");
    }

    ngOnInit() {
        // this.errorMessage = null;
        // console.log("Checking if the user is already authenticated. If so, then redirect to the secure site");
        this.userService.isAuthenticated(null, null);
    }

    async onLogin() {
        if ((this.email == null && this.email !== '') || (this.password == null && this.password !== '')) {
            this.dialog.open(ErrorDialogComponent, {
                data: {
                    error: 'fields'
                }
            });
            return;
        }

        this.errorMessage = null;

        await this.userService.authenticate(this, this.email, this.password);
        // this.userService.authenticate(this.email, this.password);
    }

    cognitoCallback(message: string, result: any) {
        if (message != null) { // error
            this.dialog.open(ErrorDialogComponent, {
                data: {
                    error: 'nouser'
                }
            });
            // console.log("result: " + this.errorMessage);
            /*if (this.errorMessage === 'User is not confirmed.') {
                // console.log("redirecting");
                this.router.navigate(['/auth/confirmRegistration', this.email]);
            } else if (this.errorMessage === 'User needs to set password.') {
                // console.log("redirecting to set new password");
                this.router.navigate(['/auth/newPassword']);
            }*/
        } else { // success
            this.router.navigate(['dashboard']);
        }
    }

    /*handleMFAStep(challengeName: string, challengeParameters: ChallengeParameters, callback: (confirmationCode: string) => any): void {
        this.mfaStep = true;
        this.mfaData.destination = challengeParameters.CODE_DELIVERY_DESTINATION;
        this.mfaData.callback = (code: string) => {
            if (code == null || code.length === 0) {
                this.errorMessage = "Code is required";
                return;
            }
            this.errorMessage = null;
            callback(code);
        };
    }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            this.router.navigate(['/securehome']);
        }
    }

    cancelMFA(): boolean {
        this.mfaStep = false;
        return false;   //necessary to prevent href navigation
    }*/
}
